import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../../models/search-toolbar-factory-parameters.model';

@Component({
  selector: 'app-promo-analysis-anagraphic',
  templateUrl: './promo-anagraphic.component.html',
  styleUrls: ['./promo-anagraphic.component.css']
})
// Pagina 51
export class PromoAnagraphicComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public promoError = false;
  public selectOneError: string;
  public data: QFilterModel;
  public datatablePromo: Array<any>;
  public datatableProduct: Array<any>;
  show_results = false;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {

    this.translations = {
      categoryInvestmentTypePromo: 'promo.categoryInvestmentTypePromo',
      averageDiscountPerStoreChannel: 'promo.averageDiscountPerStoreChannel',
      investmentContactChannel: 'promo.investmentContactChannel',
      descrizione_articolo: 'promo.descrizione_articolo',
      prezzo_base: 'promo.prezzo_base',
      descrizione_meccanica: 'promo.descrizione_meccanica',
      prodotti_promo: 'promo.prodotti_promo',
      promo_nome: 'promo.promo_nome',
      promo_tipologia: 'promo.promo_tipologia',
      promo_obiettivo: 'promo.promo_obiettivo',
      promo_periodo: 'promo.promo_periodo',
      promo_negozi: 'promo.promo_negozi',
      promo_meccanica: 'promo.promo_meccanica',
      promo_descrizione: 'promo.promo_descrizione',
      promo_target: 'promo.promo_target'
    };

  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue (data: QFilterModel) {

    this.data = data;
    if (data['promo'] != null) {

      this.indicators = [];
      this.indicatorService.indicatorCalculation('promos.Q224', this.data).subscribe(Q224 => {

        /*Q224*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'investimento_totale')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q225*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'fatturato_promo')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q226*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q227*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'spesa_associata')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q228*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'spesa_incrementale')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q229*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'roi')], {dynamic: true, decimal_value: 1, hide_prev_value: true}));
        /*Q230*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'dimensione_target')], {dynamic: true, decimal_value: 0, hide_prev_value: true}));
        /*Q231*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'redemption')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));

      });

      this.tablePromoInit(data);
      this.tableProductInit(data);
      this.show_results = true

    } else {
      this.data = null;
      this.promoError = true;
    }

  }

  public toogleErrorPromoDialog() {
    this.promoError = !this.promoError;
  }

  public tablePromoInit(data: QFilterModel) {
    this.indicatorService.getChart('promos.Q222', data).subscribe((resp) => {

      this.datatablePromo = [];
      if (resp.series.length > 0) {

        let stores = '';
        for (let i = 0; i < resp.series.length; i++) {

          let titolo = '';
          if (resp.series[i].titolo === 'nome_promo') {
            titolo = this.translations.promo_nome;
          } else if (resp.series[i].titolo === 'tipologia') {
            titolo = this.translations.promo_tipologia;
          } else if (resp.series[i].titolo === 'obiettivo') {
            titolo = this.translations.promo_obiettivo;
          } else if (resp.series[i].titolo === 'periodo_promo') {
            titolo = this.translations.promo_periodo;
          } else if (resp.series[i].titolo === 'negozi') {
            titolo = this.translations.promo_negozi;
            if (data.stores != null) {
              for (let j = 0; j < this.searchModel.stores.length; j++) {
                if (data.stores.indexOf(parseInt(this.searchModel.stores[j].code, 10)) >= 0) {
                  stores += this.searchModel.stores[j].description + ' - ';
                }
              }
            } else {
              for (let j = 0; j < this.searchModel.stores.length; j++) {
                stores += this.searchModel.stores[j].description + ' - ';
              }
            }
          } else if (resp.series[i].titolo === 'meccanica') {
            titolo = this.translations.promo_meccanica;
          } else if (resp.series[i].titolo === 'descrizione') {
            titolo = this.translations.promo_descrizione;
          } else if (resp.series[i].titolo === 'target') {
            titolo = this.translations.promo_target;
          }

          if (resp.series[i].titolo !== 'negozi') {
            this.datatablePromo.push({
              col1: titolo,
              col2: resp.series[i].serie[0]
            });
          } else {
            this.datatablePromo.push({
              col1: titolo,
              col2: stores
            });
          }
        }

      }

    });

  }

  public tableProductInit(data: QFilterModel) {
    this.indicatorService.getChart('promos.Q223', data).subscribe((resp) => {

      this.datatableProduct = [];
      if (resp.series.length > 0) {
        let serie0 = resp.series[0].serie;
        let serie1 = resp.series[1].serie;
        let serie3 = resp.series[3].serie;

        for (let i = 0; i < serie0.length; i++) {

          this.datatableProduct.push({
            descrizione_articolo: serie0[i],
            prezzo_base: Number(serie1[i]).toLocaleString ('it-IT', {minimumFractionDigits: 2}) + '€',
            descrizione_meccanica: serie3[i]

          });
        }

      }

    });

  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/analysis/anagraphic/promo-anagraphic.component.ts